export enum SOCKET_ACTIONS {
  SEND_ALL = 'SEND_ALL',
  SEND_TO_ROOM = 'SEND_TO_ROOM',

  JOIN_NEW_ROOM_SEND = 'JOIN_NEW_ROOM_SEND',
  LEAVE_NEW_ROOM_SEND = 'LEAVE_NEW_ROOM_SEND',

  NEW_MSG_SEND = 'NEW_MSG_SEND',
  NEW_MSG_RECEIVE = 'NEW_MSG_RECEIVE',

  NEW_NOTIFICATION_SEND = 'NEW_NOTIFICATION_SEND',
  NEW_NOTIFICATION_RECEIVE = 'NEW_NOTIFICATION_RECEIVE',

  NEW_TYPING_SEND = 'NEW_TYPING_SEND',
  NEW_TYPING_RECEIVE = 'NEW_TYPING_RECEIVE',

  UPDATE_USER_STATUS_SEND = 'UPDATE_USER_STATUS_SEND',
  UPDATE_USER_STATUS_RECEIVE = 'UPDATE_USER_STATUS_RECEIVE',

  UPDATE_CHAT_USERS_SEND = 'UPDATE_CHAT_USERS_SEND',
  UPDATE_CHAT_USERS_RECEIVE = 'UPDATE_CHAT_USERS_RECEIVE',

  NEW_CALL_SEND = 'NEW_CALL_SEND',
  NEW_CALL_RECEIVE = 'NEW_CALL_RECEIVE',
  NEW_CALL_ACCEPT = 'NEW_CALL_ACCEPT',
  NEW_CALL_REJECT = 'NEW_CALL_REJECT',
  NEW_CALL_CLOSE = 'NEW_CALL_CLOSE',

  NEW_TASKS_SEND = 'NEW_TASKS_SEND',
  NEW_TASKS_RECEIVE = 'NEW_TASKS_RECEIVE',
  UPDATE_TASKS_SEND = 'UPDATE_TASKS_SEND',
  UPDATE_TASKS_RECEIVE = 'UPDATE_TASKS_RECEIVE',
  DELETE_TASKS_SEND = 'DELETE_TASKS_SEND',
  DELETE_TASKS_RECEIVE = 'DELETE_TASKS_RECEIVE'
}
